import { faImages } from "@jewlr/pro-light-svg-icons/faImages"
import {
  Box,
  Button,
  FontAwesomeIcon,
  MediaBox,
  MediaFlex,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import {
  updateDisplayState,
  uploadUserImage,
} from "areas/product/store/actions"

const HiddenInput = styled.input.attrs({
  hidden: true,
})``

const UploadImgButton = styled(Button).attrs({
  borderRadius: "30px",
  fontSize: 18,
  fontWeight: 500,
  height: { _: "48px", tablet: "44px" },
  minWidth: "180px",
  mt: { _: 0, tablet: "6px" },
  variant: "primary",
})``

const UploadIcon = styled(FontAwesomeIcon).attrs({
  height: "13px",
  mr: "6px",
  width: "13px",
})``

const UploadInstructions = styled(Box).attrs((props) => ({
  color: props.theme.colors.black,
  fontSize: 18,
  fontWeight: 500,
  letterSpacing: "-0.02em",
  lineHeight: "20px",
}))``

const UploadArea = styled(MediaBox).attrs({
  borderRadius: "30px",
  lessThan: "tablet",
  mb: 3,
  position: "relative",
})``

const UploadButton = styled(Button).attrs({
  outline: "primary",
})`
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  line-height: 16px;
  height: 44px;
  opacity: ${(props) => (props.loading ? 0.5 : 1)};
  text-align: center;
  transition: background-color 300ms ease-in;
  &:disabled {
    background-color: #a0a0a0;
    color: "#FFFFFF";
  }

  ${(props) =>
    props.source === "PDP" &&
    `
    width: 100%;
  `};
`

const DragArea = styled(MediaFlex).attrs((props) => ({
  alignItems: "center",
  border: `2px dashed ${props.theme.colors.grey20}`,
  greaterThanOrEqual: "tablet",
  height: "148px",
  justifyContent: "center",
  mt: 4,
}))`
  ${(props) =>
    props.isDragging &&
    `
    background-color: #E8F8FB;
    border-color: ${props.theme.colors.selected};
  `}
`

const InternalPhotoUpload = ({
  adminMode,
  data,
  display,
  handwritingEngraving,
  isReupload,
  onUpload,
  setDragover,
  source,
  startUpload,
}) => {
  if (!data) return null

  let refs = {}

  return isReupload ? (
    <Box>
      <HiddenInput
        accept=".jpg,.jpeg,.png,.heic"
        data-crop-height={data.cropper.aspect_ratio_height}
        data-crop-mask={
          data.pref == "box"
            ? require(`images/cart/boxes/${data.cropper.mask}`)
            : `${data.cropper.mask}`
        }
        data-crop-width={data.cropper.aspect_ratio_width}
        data-crop-x={data.cropper.crop_pos_x}
        data-crop-y={data.cropper.crop_pos_y}
        data-pref={data.pref}
        data-url={data.api_v3_upload_path}
        id={`${data.pref}_upload`}
        name="file"
        onChange={() => {
          startUpload(refs.file_form, false, handwritingEngraving, onUpload)
        }}
        onClick={(e) => (e.target.value = null)}
        ref={(elem) => (refs.file_form = elem)}
        type="file"
      />
      <UploadButton
        data-pref={data.pref}
        id={`upload_${data.pref}`}
        onClick={() => refs.file_form.click()}
        selected={!isReupload}
        source={source}
        type="button"
      >
        <UploadIcon icon={faImages} />
        Replace
      </UploadButton>
    </Box>
  ) : (
    <Box>
      <HiddenInput
        accept=".jpg,.jpeg,.png,.heic"
        data-crop-height={data.cropper.aspect_ratio_height}
        data-crop-mask={
          data.pref == "box"
            ? require(`images/cart/boxes/${data.cropper.mask}`)
            : `${data.cropper.mask}`
        }
        data-crop-width={data.cropper.aspect_ratio_width}
        data-crop-x={data.cropper.crop_pos_x}
        data-crop-y={data.cropper.crop_pos_y}
        data-pref={data.pref}
        data-url={data.api_v3_upload_path}
        id={`${data.pref}_upload`}
        name="file"
        onChange={() => {
          startUpload(refs.file_form, false, handwritingEngraving, onUpload)
        }}
        ref={(elem) => (refs.file_form = elem)}
        type="file"
      />

      <UploadInstructions>
        <UploadArea>
          <Typography>
            Select an image from
            <br />
            your device or take a new photo.
          </Typography>
        </UploadArea>

        <UploadImgButton
          data-pref={data.pref}
          id={`upload_${data.pref}`}
          onClick={() => refs.file_form.click()}
          selected
          source={source}
          type="button"
        >
          <UploadIcon icon={faImages} />
          Choose {handwritingEngraving ? "Image" : "Photo"}
        </UploadImgButton>
        <Box
          onDragEnd={() => setDragover(false)}
          onDragEnter={() => setDragover(true)}
          onDragLeave={() => setDragover(false)}
          onDragOver={(e) => {
            e.preventDefault()
            setDragover(true)
          }}
          onDrop={(e) => {
            e.preventDefault()
            startUpload(e, false, handwritingEngraving, onUpload)
            setDragover(false)
          }}
        >
          <DragArea
            data-cy={`product-image-wizard-option-modal-btn-${data.pref}`}
            isDragging={display.photo_dragover}
          >
            or drag {handwritingEngraving ? "an image" : "a photo"} here
          </DragArea>
        </Box>

        {adminMode ? (
          <Box>
            <br />
            <br />
            <HiddenInput
              data-pref={data.pref}
              data-url={data.api_v3_upload_path}
              id={`${data.pref}_admin_upload`}
              name="file"
              onChange={() =>
                startUpload(refs.admin_file_form, true, handwritingEngraving)
              }
              ref={(elem) => (refs.admin_file_form = elem)}
              type="file"
            />
            <UploadImgButton
              data-pref={data.pref}
              id={`admin_upload_${data.pref}`}
              onClick={() => refs.admin_file_form.click()}
              type="button"
            >
              Admin Upload
            </UploadImgButton>
          </Box>
        ) : (
          ""
        )}
      </UploadInstructions>
    </Box>
  )
}

InternalPhotoUpload.propTypes = {
  adminMode: PropTypes.bool,
  data: PropTypes.object,
  display: PropTypes.object,
  handwritingEngraving: PropTypes.bool,
  isReupload: PropTypes.bool,
  onUpload: PropTypes.func,
  setDragover: PropTypes.func,
  source: PropTypes.string,
  startUpload: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  let data = state.wizard.data[ownProps.pref]
  let display = state.display[ownProps.pref] || {}
  const handwritingEngraving =
    ownProps.pref && state.wizard.data[ownProps.pref]?.handwriting_engraving

  return {
    adminMode: state.wizard.adminMode || false,
    data,
    display,
    handwritingEngraving,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setDragover: (dragging) => {
      dispatch(updateDisplayState(ownProps.pref, { photo_dragover: dragging }))
    },
    startUpload: (fileSource, isAdmin, isHandwriting, uploadCallback) => {
      dispatch(
        uploadUserImage(
          ownProps.pref,
          fileSource,
          isAdmin,
          uploadCallback,
          isHandwriting
        )
      )
    },
  }
}

const PhotoUpload = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalPhotoUpload)

export default PhotoUpload
